<template>
  <div class="wp_img">
    <img :src="img[0]">
    <img :src="img[1]">
  </div>
</template>

<script>
export default {
  name: "LiNian",
  data() {
    return {
      img: [require('../assets/3.jpg'),require('../assets/4.jpg')]
    }
  }
}
</script>

<style scoped lang="less">

</style>